const heatColumns = [
  {
    zh: '整机编号',
    en: 'Device Code',
    dataIndex: 'deviceCode',
    key: 'deviceCode',
    width: 280
  },
  {
    zh: '公司名称',
    en: 'Company',
    dataIndex: 'company',
    key: 'company',
    width: 460
  },
  {
    zh: '机型',
    en: 'Model',
    dataIndex: 'model',
    key: 'model'
  },
  {
    zh: '平均电流(A)',
    en: 'Average Current(A)',
    dataIndex: 'avgCurrent',
    key: 'avgCurrent',
    tooltip: true
  },
  {
    zh: '设定温度(℃)',
    en: 'Fan Temperature(℃)',
    dataIndex: 'fanTemperature',
    key: 'fanTemperature',
    tooltip: true
  },
  {
    zh: '平均温度(℃)',
    en: 'Average Temperature(℃)',
    dataIndex: 'avgTemperature',
    key: 'avgTemperature',
    tooltip: true
  },
  {
    zh: '极限温度(℃)',
    en: 'Rated Temperature',
    dataIndex: 'ratedTemperature',
    key: 'ratedTemperature',
    tooltip: true
  },
  {
    zh: '高温率',
    en: 'Percentage',
    dataIndex: 'percentage',
    key: 'percentage',
    tooltip: true
  }
]

export {
  heatColumns
}
